import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { toast } from 'sonner';
interface EditProfileModalProps {
  isOpen: boolean;
  onClose: () => void;
  userInfo: {
    name: string;
    email: string;
    phone: string;
    [key: string]: string;
  };
}
export function EditProfileModal({
  isOpen,
  onClose,
  userInfo
}: EditProfileModalProps) {
  const [name, setName] = useState(userInfo.name);
  const [email, setEmail] = useState(userInfo.email);
  const [phone, setPhone] = useState(userInfo.phone);
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success('Profile updated successfully');
    onClose();
  };
  return <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4" role="dialog" aria-modal="true" data-id="element-632" data-mp="3nw7nfvtpitjr">
      <div className="bg-white w-full max-w-lg rounded-xl shadow-xl overflow-hidden" data-id="element-633" data-mp="y6nfr9po483d">
        <div className="flex items-center justify-between p-5 border-b border-gray-200" data-id="element-634" data-mp="134yqdmnsemmn">
          <h2 className="text-lg font-bold text-gray-900" data-id="element-635" data-mp="16c4ee6gckvm5">Edit Profile</h2>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-gray-100" aria-label="Close" data-id="element-636" data-mp="12b0xdgmkctjc">
            <XIcon className="w-5 h-5" data-id="element-637" data-mp="xamo5v987djq" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-5 space-y-4" data-id="element-638" data-mp="scbfhnuo3933">
          <div data-id="element-639" data-mp="ne1id7pdtyeu">
            <label className="text-sm font-medium text-gray-700" data-id="element-640" data-mp="nejmsrm77ixu">
              Full Name
            </label>
            <input type="text" value={name} onChange={e => setName(e.target.value)} className="mt-1 w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-641" data-mp="imif7izz6ge5" />
          </div>
          <div data-id="element-642" data-mp="4o1xkx0kr5h8">
            <label className="text-sm font-medium text-gray-700" data-id="element-643" data-mp="4mh3f8i69ojw">Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="mt-1 w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-644" data-mp="3vttjfk7bjvy8" />
          </div>
          <div data-id="element-645" data-mp="3d6kqaorpcxag">
            <label className="text-sm font-medium text-gray-700" data-id="element-646" data-mp="3d6ufia4xb0f3">Phone</label>
            <input type="tel" value={phone} onChange={e => setPhone(e.target.value)} className="mt-1 w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-647" data-mp="3h6uym82yvzsh" />
          </div>
          <div className="flex gap-3 pt-2" data-id="element-648" data-mp="3w56u4belt2i2">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50" data-id="element-649" data-mp="3w4evsstmgqo3">
              Cancel
            </button>
            <button type="submit" className="flex-1 px-4 py-2.5 bg-[#1E2B55] text-white font-medium rounded-lg hover:bg-[#162041]" data-id="element-650" data-mp="whoxezkvsg80">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>;
}